<statistics-has-sample-msg></statistics-has-sample-msg>
<page-header [icon]="['SIDEMENUES', 'STATISTICS', 'VISITORS_SUMMARY'] | monIcons"
             header="{{'Visitors Summary' | translate}}"
             [subHeader]="'View data for the selected period.' | translate"
             [panelClass]="(domain | isStatsSampleData) ? 'mt-1' : ''">
    <page-header-content>
        <statistics-date-picker
                (onApply)="updateDateRange()"
                [(date)]="date"
                dateRangeGroup="statistics"
                class="pull-right">
        </statistics-date-picker>
    </page-header-content>
</page-header>
<div class="row" *ngIf="date.startDate !== ''">
    <div class="col-30">
        <div class="row">
            <div class="col-lg-24 col-md-48">
                <statistics-visitors-summary-doughnut
                    [title]="'Devices' | translate"
                    [linkText]="'Device Overview' | translate"
                    link="base.customer.domain.statistics.visitors.devices"
                    type="devices"
                    [startDate]="date.startDate"
                    [endDate]="date.endDate">
                </statistics-visitors-summary-doughnut>
            </div>
            <div class="col-lg-24 col-md-48">
                <statistics-visitors-summary-doughnut
                    [title]="'Operating systems' | translate"
                    [linkText]="'Operating systems Overview' | translate"
                    link="base.customer.domain.statistics.visitors.os"
                    type="os"
                    [startDate]="date.startDate"
                    [endDate]="date.endDate">
                </statistics-visitors-summary-doughnut>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-24 col-md-48">
                <statistics-visitors-summary-doughnut
                    [title]="'Browsers' | translate"
                    [linkText]="'Browsers Overview' | translate"
                    link="base.customer.domain.statistics.visitors.browsers"
                    type="browsers"
                    [startDate]="date.startDate"
                    [endDate]="date.endDate">
                </statistics-visitors-summary-doughnut>
            </div>
            <div class="col-24"></div>
        </div>
    </div>
    <div class="col-18">
        <statistics-visitors-summary-bubble
            [title]="'Screen Resolutions' | translate"
            [linkText]="'Screen Resolutions Overview' | translate"
            link="base.customer.domain.statistics.visitors.resolutions"
            [startDate]="date.startDate"
            [endDate]="date.endDate">
        </statistics-visitors-summary-bubble>
    </div>
</div>
